import { supabase } from "@/integrations/supabase/client";
import { getActAsCompanyId } from "@/lib/actAsCompany";

export const getCurrentUserCompanyId = async (): Promise<string | null> => {
  const { data: { user } } = await supabase.auth.getUser();

  if (!user) {
    return null;
  }

  // Global admin "act as company": use the selected company for all data
  const actAsId = getActAsCompanyId();
  if (actAsId) {
    const isGlobalAdmin = await checkUserRole("global_admin");
    if (isGlobalAdmin) return actAsId;
  }

  const { data: profile, error } = await supabase
    .from("profiles")
    .select("company_id")
    .eq("user_id", user.id)
    .single();

  if (error || !profile?.company_id) {
    return null;
  }

  return profile.company_id;
};

export const checkUserRole = async (role: 'global_admin' | 'company_admin' | 'company_user'): Promise<boolean> => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      return false;
    }

    // Use the has_role database function which bypasses RLS (SECURITY DEFINER)
    const { data, error } = await supabase
      .rpc('has_role', {
        _user_id: user.id,
        _role: role
      });

    if (error) {
      console.error('Error checking user role:', error);
      return false;
    }

    return data === true;
  } catch (error) {
    console.error('Error in checkUserRole:', error);
    return false;
  }
};
